module.exports = __webpack_public_path__ + "img/passport-wrong-alignment.54cf20cf.png";